import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Footer, MobileCallBar } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HomeWatch from "@/pages/HomeWatch";
import Concierge from "@/pages/Concierge";
import Pricing from "@/pages/Pricing";
import ServiceAreas from "@/pages/ServiceAreas";
import Contact from "@/pages/Contact";
import CommunityPage from "@/pages/CommunityPage";
import Hurricane from "@/pages/Hurricane";
import Admin from "@/pages/Admin";
import { Privacy, Terms, NotFound } from "@/pages/Legal";

let lenis = null;

const SmoothScroll = () => {
  useEffect(() => {
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      lenis = null;
    };
  }, []);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = () => (
  <>
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded focus:bg-white focus:px-4 focus:py-2">Skip to content</a>
    <Header />
    <div id="main"><Outlet /></div>
    <Footer />
    <MobileCallBar />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/home-watch-services" element={<HomeWatch />} />
          <Route path="/concierge-services" element={<Concierge />} />
          <Route path="/plans-and-pricing" element={<Pricing />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/service-areas/:slug" element={<CommunityPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/hurricane-season-home-watch" element={<Hurricane />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
